import apiClient from './client';

export async function getBalance() {
  const res = await apiClient.get('/api/currency/');
  return res.data;
  // Returns: { id, user_id, balance, total_earned, total_spent, last_daily_income_at, daily_income_streak, created_at, updated_at }
}

export async function claimDailyIncome() {
  const res = await apiClient.post('/api/currency/daily-income');
  return res.data;
  // Returns: { awarded, card_counts, streak, balance } OR { already_awarded: true, balance }
}

export async function getDailyIncomePreview() {
  const res = await apiClient.get('/api/currency/daily-income-preview');
  return res.data;
}

export async function getTransactions(limit = 50, type = null) {
  const params = { limit };
  if (type) params.type = type;
  const res = await apiClient.get('/api/currency/transactions', { params });
  return res.data;
}
